import { FC, useEffect } from 'react';
import { useLoanForm } from '../hooks';
import { FormProvider } from 'react-hook-form';
import { LoanFormContext } from '../../UI';

interface LoanFormProviderProps {
  children: React.ReactNode;
  className?: HTMLFormElement['className'];
  useLoanFormReturn: ReturnType<typeof useLoanForm>;
  registerSubmit?: (submitFn: () => void) => void; // New prop
}

/**
 *
 * @deprecated Use ElementsForm from packages/elements/src/UI/components/ElementsForm.tsx in combination with
 * useCreateLoanForm from  packages/elements/src/Loan/hooks/useCreateLoanForm.ts
 * and useEditLoanForm from  packages/elements/src/Loan/hooks/useEditLoanForm.ts
 * instead
 */
export const LoanFormProvider: FC<LoanFormProviderProps> = ({
  registerSubmit,
  children,
  className,
  useLoanFormReturn: { formMethods, onSubmit, householdID, loan },
}) => {
  useEffect(() => {
    if (registerSubmit) {
      const handleSubmit = () => formMethods.handleSubmit(onSubmit)();
      registerSubmit(handleSubmit);
    }
  }, []);
  return (
    <FormProvider {...formMethods}>
      <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
        <LoanFormContext.Provider value={{ householdID, loan }}>{children}</LoanFormContext.Provider>
      </form>
    </FormProvider>
  );
};
